import ProductAnalyticsCarousel from "features/products/components/ProductAnalyticsCarousel";
import { ProductTrendProvider } from "features/products/providers/ProductTrendProvider";
import ProductPerformanceTable from "features/products/components/ProductPerformanceTable";
import { ApiDimension, ApiMetric, ApiChartAttribute } from "@incendium/api";
import { Box } from "@mui/material";

interface IProductsTabProps {
  attributes: ApiChartAttribute[];
}

function ProductsTab({ attributes }: IProductsTabProps) {
  return (
    <ProductTrendProvider chartAttributes={attributes}>
      <ProductAnalyticsCarousel
        showAllProductsLink={false}
        chartAttributes={attributes}
      />
      <Box sx={{ height: 600, flexShrink: 0 }}>
        <ProductPerformanceTable
          excludedDimensions={[ApiDimension.DIMENSION_PRODUCT_CATEGORY]}
          excludedMetrics={[ApiMetric.METRIC_AVERAGE_MARGIN_PERCENT]}
          chartAttributes={attributes}
        />
      </Box>
    </ProductTrendProvider>
  );
}

export default ProductsTab;
